export const URL_GET_CUSTOMER_LIST = "/v1/gocheckin/customer/site/list?";
export const URL_GET_CUSTOMER_LIST_NOT_IN_GROUP = "/v1/gocheckin/group/site/list-to-add?";
export const URL_GET_A_CUSTOMER = "/v1/gocheckin/customer/site/get?";
export const URL_GET_CHART_INFO = "/v1/gocheckin/customer/site/chart-info";
export const URL_GET_CUSTOMER_HISTORY = "/v1/gocheckin/customer/history/get?";
export const URL_UPDATE_A_CUSTOMER = "/v1/gocheckin/customer/form/update";
export const URL_DELETE_A_CUSTOMER = "/v1/gocheckin/group/form/remove-customers";
export const URL_BULK_DELETE_CUSTOMERS = "/v1/gocheckin/customer/form/bulk-delete";
export const URL_GET_GROUP_LIST = "/v1/gocheckin/group/site/list?";
export const URL_UPDATE_A_GROUP= "/v1/gocheckin/group/form/update";
export const URL_CREATE_A_GROUP= "/v1/gocheckin/group/form/create";
export const URL_DELETE_A_GROUP= "/v1/gocheckin/group/form/delete";
export const URL_GET_A_GROUP_DETAIL = "/v1/gocheckin/group/site/get?";
export const URL_GET_A_DELETE_GROUP_DETAIL = "/v1/gocheckin/group/site/get?";
export const URL_UPDATE_CUSTOMER_GROUP = '/v1/gocheckin/customer/form/update-list-group';
export const URL_EXPORT_MEMBER = "v1/gocheckin/customer/site/export-member";
export const URL_GET_CUSTOMER_CALLING_INFO = "/v1/pos/customer/site/detail";
export const URL_GET_SMS_TEMPLATE = "/v1/pos/call/site/get-sms-call-template";
export const URL_SEND_SMS = "/v1/pos/call/form/send-sms";
export const URL_CREATE_CUSTOMER = "/v1/gocheckin/customer/form/create";
export const URL_EDIT_SMS = "/v1/pos/call/form/edit-sms";